import { isIntakeAfterAgentDetailsCutoff } from 'shared-components';
import { ApplicationState } from '.';
import { UserRole } from './auth/types';
import { safeLocalStorageGet } from '../utilities/localStorage';

export const getConfig = (state: ApplicationState) => state.config;
export const getUI = (state: ApplicationState) => state.ui;
export const getAuth = (state: ApplicationState) => state.auth;
export const isTesting = (state: ApplicationState) => state.auth.isTesting;
export const getIntakeId = (state: ApplicationState) => state.auth.intake;
export const getDefaultIntakeId = (state: ApplicationState) => state.config.defaultIntakeId;
export const getInstitution = (state: ApplicationState) => state.auth.institution;
export const getIntakeRange = (state: ApplicationState, intakeId: string) => {
  const x = state.config.intakeIds.find((intake: any) => intake.value === intakeId);
  return x;
};
export const getUniId = (state: ApplicationState) => state.auth.uni;

export const getPathway = (state: ApplicationState) => state.auth.pathway || state.config?.pathwayIds?.[0]?.value;

export const getPathwayAndUni = (state: ApplicationState): { pathway?: string; uni: string } => {
  const parent = getUniId(state);
  const child = getPathway(state);
  if (child) {
    return { pathway: parent, uni: child };
  }
  return { uni: parent };
};

export const isOnlyPathwayStudentsSelector = (state: ApplicationState) => {
  const isUni = !state.config.isPathway;

  const urlParams = new URL(window.location.href).searchParams;
  const paramsInstitution = urlParams.get('institution');
  const dashboardInstitutionValue = paramsInstitution || safeLocalStorageGet('dashboard-uni-institution-value');
  return isUni && dashboardInstitutionValue === 'pathway';
};

export const isLoading = (state: ApplicationState) => state.ui.isLoading;

export const getCurrentAgency = (state: ApplicationState) => state.agencies.currentAgency;
export const getHeaderTab = (state: ApplicationState) => state.ui.headerTab;
export const getIsWsPaused = (state: ApplicationState) => state.data.isWsPaused;

export const getWSConnected = (state: ApplicationState) => state.auth.wsConnected;
export const getWebsocket = (state: ApplicationState) => state.websocket;
export const getRole = (state: ApplicationState) => state?.auth.role;
export const getHasPathwayids = (state: ApplicationState) => (state?.config?.pathwayIds?.length ?? 0) > 0;
export const getPartners = (state: ApplicationState) => state?.config.partners;
export const getIsAdminOrEnroly = (state: ApplicationState) =>
  [UserRole.Admin, UserRole.Enroly].includes(state?.auth?.role) ?? false;
export const getIsPartner = (state: ApplicationState) => state?.auth?.role?.includes('Partner') ?? false;
export const getIsImmigrationProvider = (state: ApplicationState) =>
  state?.auth?.role?.includes('ImmigrationProvider') ?? false;
export const getIsOfferEnabled = (state: ApplicationState) => !!state?.config.offerEnabled;
export const getHasAgentOnlyDocs = (state: ApplicationState) => !!state?.config.hasAgentOnlyDocs;
export const getStudent = (state: ApplicationState) => state.student;
export function getStudentData(state: ApplicationState) {
  return {
    ...state.student.personalInfo,
  };
}
export const getIdentityDetails = (state: ApplicationState, interviewHash: string) => {
  // @ts-expect-error - recordedInterviews is not in IOffer type but exists at runtime
  const { recordedInterviews } = state.student.offer;
  const data: { videoId?: string; passport?: string; score?: number } = {};
  if (!recordedInterviews) return null;

  const interview = Object.entries(recordedInterviews)
    .map(item => {
      const [interviewHash, interview] = item;
      return {
        ...(interview as any),
        interviewHash,
      };
    })
    .find(interview => interview.interviewHash === interviewHash);
  if (interview) data.videoId = interview?.videoId || '';
  data.score = interview?.facialRecognitionScore;
  return data;
};

//TODO: remove or rename ALL OF THESE due to more dashboards being added- ambiguos name.
export const getAllSelected = (state: ApplicationState) => {
  return state.dashboard.allSelected;
};
export const getTabs = (state: ApplicationState) => {
  return state.dashboard.tabs;
};
export const getSelectedRows = (state: ApplicationState) => {
  return state.dashboard.selectedRows;
};
export const selectIntakeAfterCutoff = (state: ApplicationState): boolean =>
  isIntakeAfterAgentDetailsCutoff(state.student.offer.intakeId, state.student.summary?.uni ?? '');
